const getApiConfig = () => {
  const isProduction = window.location.hostname !== 'localhost';

  if (isProduction) {
    return {
      baseURL: '',
      environment: 'production'
    };
  } else {
    return {
      baseURL: 'http://localhost:5000',
      environment: 'development'
    };
  }
};

export const API_CONFIG = getApiConfig();
